import styled from 'styled-components';

export const StyledTh = styled.th<{ isDragging: boolean }>`
  cursor: move;
  opacity: ${({ isDragging }) => (isDragging ? 0 : 1)};
  border-right: 1px solid ${({ theme }) => theme.colors.system.grey};
`;
